/**图文回复的字段 */
import { BaseModel } from '../BaseModel';

export class WxTextImg extends BaseModel {
    GraphicId: number = 0
    Type: number = 1
    Nature:number=1
    Contents: string = ""
    Keyword: string = ""
    GraphicTitle: string = ""
    UpdaterName: string = ""
    CoverImage: string = ""
    Reward:number=0
    SortId:number=0
    Comment:number=0
    FollowDisplay:number=0
    DetailImage:number=0
    OnlyFansCanComment:number=0
    State:number=1//审核状态
    ThumbMediaId:string=""
    Synchronize:number=0
    ContentSourceUrl:string=""
    switchType:boolean=false
    switchDetailImage:boolean=false
    switchReward:boolean=false
    switchComment:boolean=false
    switchFollowDisplay:boolean=true
    switchState:boolean=true
    switchOnlyFansCanComment:boolean=false;
}